import { render, staticRenderFns } from "./ZeroLink.vue?vue&type=template&id=0fef1737"
import script from "./ZeroLink.vue?vue&type=script&lang=js"
export * from "./ZeroLink.vue?vue&type=script&lang=js"
import style0 from "./ZeroLink.vue?vue&type=style&index=0&id=0fef1737&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports